import React, { useState } from 'react';
import { useNavigate, Navigate } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { useData } from '../context/DataContext';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Lock, Shield, Eye, EyeOff } from 'lucide-react';
import { toast } from '../hooks/use-toast';

export default function AdminLogin() {
  const { login, authed } = useData();
  const navigate = useNavigate();
  const [user, setUser] = useState('');
  const [pw, setPw] = useState('');
  const [showPw, setShowPw] = useState(false);

  if (authed) return <Navigate to="/admin/panel" replace />;

  const submit = async (e) => {
    e.preventDefault();
    const ok = await login(user.trim(), pw);
    if (ok) {
      toast({ title: 'Welcome back', description: 'Signed in to the admin panel.' });
      navigate('/admin/panel');
    } else {
      toast({ title: 'Invalid credentials', description: 'Please check your username and password.', variant: 'destructive' });
    }
  };

  return (
    <>
      <Header />
      <section className="min-h-[70vh] flex items-center justify-center py-16 bg-gradient-to-b from-mist to-white">
        <div className="w-full max-w-md px-5">
          <div className="bg-white border border-slate-200 rounded-3xl p-8 shadow-xl">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-12 h-12 rounded-2xl bg-blue-700 text-white flex items-center justify-center">
                <Shield className="w-6 h-6" />
              </div>
              <div>
                <div className="text-xs uppercase tracking-wider font-bold text-blue-700">Restricted</div>
                <h1 className="font-display text-2xl font-extrabold text-navy">Admin Sign In</h1>
              </div>
            </div>
            <form onSubmit={submit} className="space-y-4">
              <div>
                <Label htmlFor="user">Username</Label>
                <Input id="user" data-testid="admin-login-username" value={user} onChange={e => setUser(e.target.value)} autoComplete="username" className="mt-1.5 h-12 rounded-xl" placeholder="Username" />
              </div>
              <div>
                <Label htmlFor="pw">Password</Label>
                <div className="relative">
                  <Input id="pw" data-testid="admin-login-password" type={showPw ? 'text' : 'password'} value={pw} onChange={e => setPw(e.target.value)} autoComplete="current-password" className="mt-1.5 h-12 rounded-xl pr-11" placeholder="••••••••" />
                  <button type="button" onClick={() => setShowPw(v => !v)} className="absolute right-3 top-1/2 -translate-y-1/2 mt-0.5 text-slate-500 hover:text-navy">
                    {showPw ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
                  </button>
                </div>
              </div>
              <Button type="submit" size="lg" data-testid="admin-login-submit" className="w-full bg-royal hover:bg-royal-dark text-white font-bold h-12 rounded-xl">
                <Lock className="w-4 h-4 mr-2" /> Sign in
              </Button>
            </form>
            <p className="mt-5 text-xs text-slate-500 text-center">Access is limited to authorized site administrators only.</p>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
}
